import { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useThemeContext from "../../hooks/useThemeContext";

interface Props {
  children: ReactNode;
}
const AuthGuard: FC<Props> = ({ children }) => {
  const Redirect = useNavigate();
  const { isAuthenticated } = useAuth();
  const { darkMode } = useThemeContext();

  return (
    <>
      {!darkMode ||
      darkMode === "DARK" ||
      (darkMode === "LIGHT" && isAuthenticated)
        ? children
        : Redirect("/session/signin")}
    </>
  );
};

export default AuthGuard;
